import type { FunctionComponent } from 'react';
import { Button, Card, Text, Loader, Center, Stack } from '@mantine/core';

type ErrorStateProps = {
  'data-testid'?: string;
  errorMessage?: string;
  isLoading?: boolean;
  color?: 'primary' | 'secondary';
  showRefresh?: boolean;
};

export const ErrorState: FunctionComponent<ErrorStateProps> = ({
  'data-testid': testId,
  errorMessage = '',
  isLoading = false,
  color = 'primary',
  showRefresh = true,
}) => {
  const handleRefreshClick = () => {
    window.location.reload();
  };

  const bg = color === 'secondary' ? 'var(--surface-secondary)' : undefined;

  return (
    <Card p="xl" bg={bg} data-testid={testId}>
      <Stack ta="center" gap="xs">
        {isLoading ? (
          <Center>
            <Loader />
          </Center>
        ) : (
          <>
            {/* TODO: use GENERIC_QUERY_ERROR_MESSAGE from 'constants/error' */}
            <Text variant="sublabel-md" ta="center">
              Oops! There was an issue loading your data.
            </Text>
            {errorMessage && <Text ta="center">{errorMessage}</Text>}
            {showRefresh && (
              <Center>
                <Button onClick={handleRefreshClick} variant="outline" size="sm">
                  Refresh
                </Button>
              </Center>
            )}
          </>
        )}
      </Stack>
    </Card>
  );
};
